export * from './src/ngx-page-scroll.directive';
export * from './src/ngx-page-scroll.service';
export * from './src/ngx-page-scroll-config';
export * from './src/ngx-page-scroll-instance';
export * from './src/ngx-page-scroll-util.service';
export * from './src/ngx-page-scroll.module';
